/** 場館前台（會員卡外連） */
export const SEAT_BOOKING_URL = 'https://sglrt.thesingularity.tw/venue/p/booking';

/** 預約站會員中心（/card「座位預約」導向） */
export const VENUE_MEMBER_CENTER_URL = 'https://sglrt.thesingularity.tw/venue/me';

/** 主辦前台（月曆入口；同網域 venue SPA） */
export const ORGANIZER_PORTAL_URL = '/organizer/calendar';

/** 活動場地介紹（CMS） */
export const VENUE_INTRO_URL = 'https://sglrt.thesingularity.tw/venue/p/venue-intro';
